<template>
    <div class="category-node">
      <input
        type="checkbox"
        :id="`cat-${node.id}`"
        :checked="isChecked"
        @change="toggleCheckbox"
      />
      <label :for="`cat-${node.id}`">{{ node.title }}</label>
  
      <div v-if="node.children && node.children.length" class="children">
        <CategoryTreeCheckbox
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          :model-value="modelValue"
          @update:model-value="$emit('update:model-value', $event)"
        />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CategoryTreeCheckbox',
    props: {
      node: {
        type: Object,
        required: true
      },
      modelValue: {
        type: Array,
        required: true
      }
    },
    emits: ['update:model-value'],
    computed: {
      isChecked() {
        return this.modelValue.includes(this.node.id);
      }
    },
    methods: {
      toggleCheckbox(event) {
        const checked = event.target.checked;
        let newValue = [...this.modelValue];
        if (checked) {
          if (!newValue.includes(this.node.id)) {
            newValue.push(this.node.id);
          }
        } else {
          newValue = newValue.filter(id => id !== this.node.id);
        }
        this.$emit('update:model-value', newValue);
      }
    }
  };
  </script>
  
  <style scoped>
  .category-node {
    margin-left: 0.5rem;
  }
  .children {
    margin-left: 1rem;
    border-left: 1px dashed #ccc;
    padding-left: 0.5rem;
  }
  </style>
  